var React = require('react');

function Quote1Grey (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M48.5833 30.917L39.75 57.417H48.5833V79.5003H26.5V57.417L35.3333 30.917H48.5833Z","fill":"#DEE2E6","key":0}),React.createElement("path",{"opacity":"0.3","fillRule":"evenodd","clipRule":"evenodd","d":"M83.9167 30.917L75.0833 57.417H83.9167V79.5003H61.8333V57.417L70.6667 30.917H83.9167Z","fill":"#DEE2E6","key":1})]);
}

Quote1Grey.defaultProps = {"width":"106","height":"106","viewBox":"0 0 106 106","fill":"none"};

module.exports = Quote1Grey;

Quote1Grey.default = Quote1Grey;
